<template>
  <div class="tracking-detail" v-if="dataPermission && dataPermission.includes('CNPS_TKLC_SEARCH')">
    <div class="breadcrumb-area pos-relative">
      <h1>Chi tiết tracking</h1>
    </div>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search">
          <div class="form-group">
            <DateRangePicker
              :ranges="false"
              class="w-100"
              v-model="dateRange"
              :locale-data="localeData"
            >
              <template v-slot:input="picker">
                <label style="min-width: 13.5em">
                  {{ picker.startDate | formatDate }} -
                  {{ picker.endDate | formatDate }}
                </label>
              </template>
              <!--Optional scope for the input displaying the dates -->
            </DateRangePicker>
          </div>
          <div class="d-inline-block">
            <a
              href="#"
              class="btn btn-primary hc-37 mr-2 m-b-10 pt-2"
              data-toggle="tooltip"
              data-placement="top"
              title="Lọc"
              @click="clickSearch"
            >
              <i class="bx bx-filter-alt"></i>
              <span>&nbsp;</span>
              Lọc
            </a>
            <a
              href="#"
              class="btn btn-outline-light hc-37 mr-2 m-b-10 pt-2"
              data-toggle="tooltip"
              data-placement="top"
              title="Lọc"
              @click="clearSearch"
            >
              <i class="bx bx-filter-alt"></i>
              <span>&nbsp;</span>
              Bỏ lọc
            </a>
          </div>
        </form>
      </div>
      <div class="card-body b-t-1-869fb229">
        <div class="mt-4">
          <span class="de-img"><img src="@/assets/img/user.svg" alt="img" /></span>
          <div class="de-info">
            <h3 class="de-name">{{ dataInfoStaff.name }}</h3>
            <span class="s">SĐT: {{ dataInfoStaff.mobile }}</span
            ><br />
            <span class="s">Mail: {{ dataInfoStaff.userName }}</span>
          </div>
        </div>

        <div class="clearfix"></div>
        <div class="form-row mt-4">
          <div class="col-md-12">
            <div class="box-maps">
              <GmapMap
                ref="map"
                :center="markersCenter"
                :zoom="zoomNumber"
                :clickable="true"
                style="width: 100%; height: 800px"
              >
                <GmapMarker :position="markersCenter"></GmapMarker>
                <GmapMarker
                  :key="index"
                  v-for="(m, index) in markers"
                  :position="m.position"
                  :icon="{
                    url: require(`${m.appOnForeground ? './icon/onl.png' : './icon/off.png'}`),
                    scaledSize: m.showClick
                      ? { width: 60, height: 100 }
                      : { width: 25, height: 40 },
                  }"
                  @click="toggleInfo(m, index)"
                  :clickable="true"
                >
                </GmapMarker>
                <gmap-info-window
                  :options="infoOptions"
                  :position="infoWindowPos"
                  :opened="infoWinOpen"
                  @closeclick="infoWinOpen = false"
                >
                  <div v-html="infoContent"></div>
                </gmap-info-window>
                <GmapPolygon :paths="paths"></GmapPolygon>
              </GmapMap>
            </div>
          </div>
        </div>

        <div class="table-responsive mt-4">
          <div class="box-header">
            Tổng số: <strong class="text-primary">{{ totalTracking }}</strong> &nbsp;&nbsp;|
            &nbsp;&nbsp; Hoạt động:
            <strong class="text-primary">{{ quantityActive }}</strong> &nbsp;&nbsp;| &nbsp;&nbsp; Đã
            khóa: <strong class="text-primary">{{ quantityInactive }}</strong>
          </div>
          <table class="table table-hover table-bordered" id="tableScroll">
            <thead class="thead-light">
              <tr>
                <th class="text-center" style="width: 50px">STT</th>
                <th>Thời gian</th>
                <th>Địa chỉ</th>
                <th>Lat / Long</th>
                <th>Trạng thái</th>
                <th>Loại thiết bị</th>
              </tr>
            </thead>
            <tbody>
              <tr class="table-row" v-for="(point, index) in dataItems" :key="index">
                <td class="text-center" style="width: 50px">
                  {{ pagination.size * (pagination.page - 1) + index + 1 }}
                </td>
                <td>{{ point.lastUpdated | formatDate('DD/MM/YYYY HH:mm:ss') }}</td>
                <td>{{ point.address ? point.address : '' }}</td>
                <td>
                  <a
                    href="javascript:void(0)"
                    @click="showMapLocation(point.latitude, point.longitude)"
                    >{{ point.latitude }} / {{ point.longitude }}</a
                  >
                </td>
                <td>
                  <span class="badge badge-primary" v-if="point.appOnForeground">
                    Đang hoạt động
                  </span>
                  <span class="badge badge-danger" v-else> Đã tắt </span>
                </td>
                <td>{{ point.deviceType === 'android' ? 'Android' : 'IOS' }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="pagination-bottom">
          <b-pagination
            v-model="pagination.page"
            :total-rows="pagination.totalRows"
            :per-page="pagination.size"
            @input="paginationChange"
            class="fl-right mr-2"
          ></b-pagination>
        </div>
      </div>
    </div>

    <b-modal ref="modal-map" centered hide-footer hide-header size="lg">
      <div>
        <GmapMap
          :center="{ lat: latitude, lng: longtitude }"
          :zoom="12"
          map-type-id="terrain"
          style="width: 100%; height: 500px"
        >
          <gmap-marker :position="{ lat: latitude, lng: longtitude }"></gmap-marker>
        </GmapMap>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import axios from 'axios'
  import Config from '../../thirdParty/config'
  import { TrackingService } from '@/services/tracking.service'
  import { StaffService } from '@/services/staff.service'
  import moment from 'moment'
  import { GOOGLE_API_TOKEN } from '@/env.js'
  import { mapGetters } from 'vuex'

  export default {
    data() {
      return {
        markers: [],
        paths: [],
        markersCenter: {
          lat: Config.positionNexttech.lat,
          lng: Config.positionNexttech.lng,
        },
        zoomNumber: 14,
        dateRange: {
          startDate: new Date(),
          endDate: new Date(),
        },
        dataInfoStaff: [],
        dataPoints: [],
        search: {},
        pagination: {
          page: 1,
          totalRows: 0,
          size: 20,
        },
        localeData: {
          direction: 'ltr',
          format: 'dd/mm/yyyy',
          separator: ' - ',
          applyLabel: 'Áp dụng',
          cancelLabel: 'Hủy bỏ',
          weekLabel: 'W',
          daysOfWeek: ['CN', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7'],
          monthNames: [
            'Tháng 1',
            'Tháng 2',
            'Tháng 3',
            'Tháng 4',
            'Tháng 5',
            'Tháng 6',
            'Tháng 7',
            'Tháng 8',
            'Tháng 9',
            'Tháng 10',
            'Tháng 11',
            'Tháng 12',
          ],
          firstDay: 0,
        },
        dataItems: [],
        dataList: [],
        longtitude: 10,
        latitude: 10,
        totalTracking: null,
        infoOptions: {
          pixelOffset: {
            width: 0,
            height: -100,
          },
        },
        currentMidx: null,
        infoWinOpen: false,
        infoContent: '',
        infoWindowPos: {
          lat: 0,
          lng: 0,
        },
      }
    },

    created() {
      this.search.userId = this.$route.query.id
      // console.log(this.search.userId)
      this.getInfoStaff()
      this.getDetailTracking()
    },

    methods: {
      // get info staff
      async getInfoStaff() {
        try {
          const response = await StaffService.getStaffById({
            userId: this.search.userId,
          })
          if (response.success) {
            this.dataInfoStaff = response.data
          }
        } catch (error) {
          console.log(error)
        }
      },

      // get address from latitude and longitude
      async getAddressFrom(lat, long) {
        let data = ''
        await axios
          .get(
            'https://maps.googleapis.com/maps/api/geocode/json?latlng=' +
              lat +
              ',' +
              long +
              `&key=${GOOGLE_API_TOKEN}`
          )
          .then(response => {
            data = response.data.results[0] ? response.data.results[0].formatted_address : ''
          })
          .catch(error => {
            console.log(error)
          })

        return data
      },

      // get detail tracking
      async getDetailTracking() {
        try {
          this.search.startTime = moment(this.dateRange.startDate)
            .startOf('day')
            .add(7, 'hours')
            .valueOf()

          this.search.endTime = moment(this.dateRange.endDate)
            .endOf('day')
            .add(7, 'hours')
            .valueOf()

          const response = await TrackingService.detailTracking(this.search)
          // console.log(response)
          this.dataList = response.data
          this.totalTracking = response.data.length
          this.dataItems = []
          if (response.code === 1000) {
            this.pagination.totalRows = response.data.length
            this.dataList = response.data

            this.markersCenter = {
              lat: parseFloat(this.dataList[this.dataList.length - 1].latitude),
              lng: parseFloat(this.dataList[this.dataList.length - 1].longitude),
            }

            const tempMarkers = []
            const tempPaths = []
            this.dataList.map(async (item, index) => {
              // const dataAddress = await this.getAddressFrom(parseFloat(item.latitude), parseFloat(item.longitude))
              // this.dataList[index].address = dataAddress

              tempMarkers.push({
                appOnForeground: item.appOnForeground,
                position: {
                  lat: parseFloat(item.latitude),
                  lng: parseFloat(item.longitude),
                },
                address: item.address ? item.address : '',
              })

              tempPaths.push({
                lat: parseFloat(item.latitude),
                lng: parseFloat(item.longitude),
              })
            })
            this.markers = tempMarkers
            this.paths = tempPaths
            this.paginationChange(1)
          }
        } catch (error) {
          console.log(error)
        }
      },

      async paginationChange(pageIndex) {
        this.pagination.page = pageIndex
        this.dataItems = []
        const mod = this.pagination.totalRows % this.pagination.size
        if (mod === 0 || (pageIndex - 1) * this.pagination.size < this.pagination.totalRows - mod) {
          for (
            let i = (pageIndex - 1) * this.pagination.size;
            i < pageIndex * this.pagination.size;
            i++
          ) {
            this.dataItems.push(this.dataList[i])
          }
        } else {
          for (let i = this.pagination.totalRows - mod; i < this.pagination.totalRows; i++) {
            this.dataItems.push(this.dataList[i])
          }
        }
      },

      clickSearch() {
        this.getDetailTracking()
      },

      clearSearch() {
        this.dateRange.startDate = new Date()
        this.dateRange.endDate = new Date()
        this.getDetailTracking()
        this.zoomNumber = 14
      },

      showMapLocation(lat, long) {
        this.latitude = parseFloat(lat)
        this.longtitude = parseFloat(long)
        this.markers.map((e, i) => {
          if (e.position.lat === this.latitude && e.position.lng === this.longtitude) {
            this.markers[i].showClick = true
          } else {
            this.markers[i].showClick = false
          }
        })

        window.scrollTo(0, 250)
        this.markersCenter = {
          lat: parseFloat(lat),
          lng: parseFloat(long),
        }
        this.zoomNumber = 20
        // this.$refs['modal-map'].show()
      },

      toggleInfo(marker, idx) {
        this.infoWindowPos = marker.position
        this.infoContent = this.getInfoWindowContent(marker)

        if (marker.showClick) this.infoWinOpen = !this.infoWinOpen
      },

      getInfoWindowContent: function (marker) {
        return '' + '<div>Địa chỉ: <b>' + (marker.address ? marker.address : '') + '</b></div>'
      },
    },
    computed: {
      quantityActive() {
        return this.dataList.filter(item => item.appOnForeground === true).length
      },
      quantityInactive() {
        return this.dataList.filter(item => item.appOnForeground === false).length
      },
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },
  }
</script>
